var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLevelRoundEvcp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Selector_Splash",
    "data-name": "Level Selector Splash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.884,
    height: 75.884,
    viewBox: "0 0 75.884 75.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.551,
    x2: 0.552,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01b138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6929"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M37.942,0A37.942,37.942,0,1,1,0,37.942,37.942,37.942,0,0,1,37.942,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M4363.556,2220.594h-.625a14.437,14.437,0,0,1-5.311-1.254,15.19,15.19,0,0,1-5-3.3c-2.333-2.46-5.237-5.522-7.852-13.949a5.848,5.848,0,0,1-1.727-1.437,9.16,9.16,0,0,1-1.989-5.433,15.137,15.137,0,0,1,.518-5.819,8.388,8.388,0,0,1,1.937-3.085V2183c-.006-2.412-.021-8.062,2.524-11.544a17.056,17.056,0,0,1,5.306-5.082c2.837-1.65,6.492-2.506,11.172-2.617l1.312,0c4.73.1,8.421.947,11.283,2.6a17.041,17.041,0,0,1,5.341,5.1c2.548,3.486,2.532,9.133,2.525,11.544v3.317a8.385,8.385,0,0,1,1.937,3.085,15.1,15.1,0,0,1,.516,5.819,9.424,9.424,0,0,1-1.989,5.433,5.615,5.615,0,0,1-1.726,1.438c-2.617,8.43-5.518,11.49-7.849,13.948A16.369,16.369,0,0,1,4363.556,2220.594Zm-18.723-31.228h0c-.513.8-.854,1.9-.854,4.65a7.079,7.079,0,0,0,1.615,4.723,5.074,5.074,0,0,0,1.612,1.245c1.924,6.2,4.155,10.581,6.821,13.39a14.212,14.212,0,0,0,8.953,3.958h.543a14.2,14.2,0,0,0,8.953-3.958c2.664-2.8,4.9-7.184,6.822-13.39a4.9,4.9,0,0,0,1.613-1.245,6.907,6.907,0,0,0,1.614-4.723c0-2.766-.347-3.868-.867-4.671l-2.3,3.066a5.6,5.6,0,0,1-4.277,2.124,6.254,6.254,0,0,1-2.126-.4l-.295-.108-.015-.005c-3.864-1.4-5.992-2.177-9.271-2.177h-.253c-3.286,0-5.418.776-9.289,2.184l-.292.106a6.242,6.242,0,0,1-2.125.4,5.582,5.582,0,0,1-4.276-2.124l-2.3-3.045Zm18.176-4.37a45.742,45.742,0,0,0-11.788,1.419,21.211,21.211,0,0,0-3.978,1.419s.035.042.089.111c1.665,2.085,2.217,2.829,2.388,3.086a1.71,1.71,0,0,0,1.452.569,4.395,4.395,0,0,0,.918-.1,7.877,7.877,0,0,0,1.245-.414c.506-.2,1.2-.467,2.346-.843a22.7,22.7,0,0,1,6.859-1.277l1.4.006a22.606,22.606,0,0,1,6.715,1.271c1.145.375,1.836.645,2.342.841l.005,0a7.9,7.9,0,0,0,1.243.414,4.426,4.426,0,0,0,.919.1,1.709,1.709,0,0,0,1.452-.569c.424-.636,2.458-3.172,2.478-3.2a21.054,21.054,0,0,0-3.977-1.419,45.751,45.751,0,0,0-11.788-1.419Z",
    transform: "translate(-4325.183 -2154.229)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelRoundEvcp);
export default __webpack_public_path__ + "static/media/icon_level_round_EVCP.57a8c8b57b6bcefd4f2b70c17583b269.svg";
export { ForwardRef as ReactComponent };